"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sum_1 = __importDefault(require("lodash/sum"));
const euclid_1 = require("@reality/euclid");
const region_utils_1 = require("@reality/region-utils");
const react_1 = __importStar(require("react"));
const FPS_BUFFER_LEN = 25;
class RealityRenderer extends react_1.Component {
    constructor(props) {
        super(props);
        this.lastFrame = performance.now();
        this.fpsBuffer = [];
        this.handleMouseMove = (e) => {
            const { onMouseMove, renderOptions } = this.props;
            if (onMouseMove) {
                onMouseMove(getScreenCoordsForEvent(e, renderOptions));
            }
        };
        this.handleMouseDown = (e) => {
            const { onMouseDown, renderOptions } = this.props;
            if (onMouseDown) {
                onMouseDown(getScreenCoordsForEvent(e, renderOptions));
            }
        };
        this.handleMouseUp = (e) => {
            const { onMouseUp, renderOptions } = this.props;
            if (onMouseUp) {
                onMouseUp(getScreenCoordsForEvent(e, renderOptions));
            }
        };
        this.handleMouseLeave = (e) => {
            const { onMouseLeave, renderOptions } = this.props;
            if (onMouseLeave) {
                onMouseLeave(getScreenCoordsForEvent(e, renderOptions));
            }
        };
        this.canvasRef = react_1.default.createRef();
    }
    shouldComponentUpdate() {
        return false;
    }
    updateFPS() {
        const now = performance.now();
        const delta = now - this.lastFrame;
        this.lastFrame = now;
        this.fpsBuffer.unshift(delta);
        this.fpsBuffer.splice(FPS_BUFFER_LEN);
    }
    renderFPS(context) {
        const fps = 1000 / (sum_1.default(this.fpsBuffer) / this.fpsBuffer.length);
        context.font = "16px CatV";
        context.fillStyle = "#33ff3a";
        context.textAlign = "left";
        context.fillText(`FPS: ${Math.round(fps)}`, 20, 20);
    }
    componentDidMount() {
        const { renderOptions } = this.props;
        if (this.canvasRef.current) {
            const context = this.canvasRef.current.getContext("2d", {
                alpha: false,
            });
            context.imageSmoothingEnabled = false;
            const renderParams = {
                renderOptions,
                effectiveTileWidth: renderOptions.canvasWidth / renderOptions.viewportWidth,
                effectiveTileHeight: renderOptions.canvasHeight / renderOptions.viewportHeight,
            };
            const renderFunc = () => {
                const { region, getCenterCoord, entityManager, resourceManager, animationManager } = this.props;
                render(context, renderParams, region, getCenterCoord(), entityManager.getEntityList(), resourceManager, animationManager);
                // calculate FPS regardless of observation
                this.updateFPS();
                if (this.props.showStats) {
                    this.renderFPS(context);
                }
                requestAnimationFrame(renderFunc);
            };
            renderFunc();
        }
        else {
            console.error("Did not resolve canvas ref in renderer");
        }
    }
    render() {
        const { canvasStyles, renderOptions } = this.props;
        return (react_1.default.createElement("canvas", { onMouseDown: this.handleMouseDown, onMouseMove: this.handleMouseMove, onMouseUp: this.handleMouseUp, onMouseLeave: this.handleMouseLeave, style: canvasStyles, height: renderOptions.canvasHeight, width: renderOptions.canvasWidth, ref: this.canvasRef }));
    }
}
function render(context, renderParams, region, centerCoord, entities, resourceManager, animationManager) {
    drawBackground(context, renderParams);
    drawSlot(region_utils_1.LayerSlot.UnderPlayer, context, region, centerCoord, resourceManager, renderParams);
    for (const entity of entities) {
        drawEntity(context, entity, centerCoord, resourceManager, animationManager, renderParams);
        // TODO - Better plan for saving and restoring drawing state.
        let { x, y } = trueEntityPosition(entity, centerCoord, renderParams, animationManager);
        const oldFill = context.fillStyle;
        const oldStroke = context.strokeStyle;
        context.translate(x, y);
        entity.doDecorationRenderer(context);
        context.resetTransform();
        context.fillStyle = oldFill;
        context.strokeStyle = oldStroke;
    }
    drawSlot(region_utils_1.LayerSlot.OverPlayer, context, region, centerCoord, resourceManager, renderParams);
}
const trueEntityPosition = (entity, centerCoord, renderParams, animationManager) => {
    let coord = region_utils_1.RegionUtils.worldCoordToScreenCoord(entity.entityState.position, centerCoord, {
        viewportHeight: renderParams.renderOptions.viewportHeight,
        viewportWidth: renderParams.renderOptions.viewportWidth,
    });
    coord = euclid_1.CoordinateUtils.add(coord, animationManager.getAnimationDisplacement(entity.instanceID));
    coord = euclid_1.CoordinateUtils.add(coord, { x: 0.5, y: 0.5 });
    coord = {
        x: coord.x * renderParams.effectiveTileWidth,
        y: coord.y * renderParams.effectiveTileHeight,
    };
    return coord;
};
function drawBackground(canvasContext, renderParams) {
    canvasContext.fillStyle = "black";
    canvasContext.fillRect(0, 0, renderParams.effectiveTileWidth * renderParams.renderOptions.viewportWidth, renderParams.effectiveTileHeight * renderParams.renderOptions.viewportHeight);
}
function drawSlot(slot, canvasContext, region, centerCoord, resourceManager, renderParams) {
    var _a;
    const { viewportHeight, viewportWidth } = renderParams.renderOptions;
    // render from bottom right up to bottom left so layers that are bigger than 1x1
    // are rendered on top of instead of below layers below and to the right of them
    const xMax = Math.min(region.width - 1, Math.floor(centerCoord.x) + viewportWidth);
    const xMin = Math.max(0, Math.floor(centerCoord.x) - viewportWidth);
    const yMax = Math.min(region.height - 1, Math.floor(centerCoord.y) + viewportHeight);
    const yMin = Math.max(0, Math.floor(centerCoord.y) - viewportHeight);
    for (let x = xMax; x >= xMin; x--) {
        for (let y = yMax; y >= yMin; y--) {
            const screenCoord = region_utils_1.RegionUtils.worldCoordToScreenCoord({ x, y }, centerCoord, {
                viewportHeight,
                viewportWidth,
            });
            const tile = region.map[x][y];
            const layers = (_a = tile === null || tile === void 0 ? void 0 : tile[slot]) !== null && _a !== void 0 ? _a : [];
            layers.forEach((layerRef) => {
                var _a;
                const resource = resourceManager.getResource(layerRef.resourceID);
                const layer = resource.layers[layerRef.layerID];
                const layerSize = (_a = layer === null || layer === void 0 ? void 0 : layer.size) !== null && _a !== void 0 ? _a : { width: 1, height: 1 };
                const spriteSize = resource.spriteSize;
                const img = resourceManager.getImg(layerRef.resourceID);
                const sx = layer.sprite.x * spriteSize;
                const sy = layer.sprite.y * spriteSize;
                const dx = Math.round(screenCoord.x * renderParams.effectiveTileWidth);
                const dy = Math.round(screenCoord.y * renderParams.effectiveTileHeight);
                canvasContext.drawImage(img, sx, sy, spriteSize * layerSize.width, spriteSize * layerSize.height, dx, dy, renderParams.effectiveTileWidth * layerSize.width, renderParams.effectiveTileHeight * layerSize.height);
            });
        }
    }
}
function drawEntity(canvasContext, entity, centerCoord, resourceManager, animationManager, renderParams) {
    const spritesheet = resourceManager.getResource(entity.baseManifest.resource);
    const tileSize = renderParams.renderOptions.tileSize;
    const screenCoord = region_utils_1.RegionUtils.worldCoordToScreenCoord(entity.entityState.position, centerCoord, {
        viewportHeight: renderParams.renderOptions.viewportHeight,
        viewportWidth: renderParams.renderOptions.viewportWidth,
    });
    const layers = animationManager.getAnimationLayers(entity.instanceID) || entity.baseManifest.states[entity.entityState.viewState].layers;
    const animationCoord = euclid_1.CoordinateUtils.add(screenCoord, animationManager.getAnimationDisplacement(entity.instanceID));
    layers.forEach((layerRef) => {
        const { x, y } = spritesheet.layers[layerRef.layerID].sprite;
        canvasContext.drawImage(resourceManager.getImg(spritesheet.resourceID), x * tileSize, y * tileSize, tileSize, tileSize, animationCoord.x * renderParams.effectiveTileWidth, animationCoord.y * renderParams.effectiveTileHeight, renderParams.effectiveTileWidth, renderParams.effectiveTileHeight);
    });
}
function getScreenCoordsForEvent(e, renderOptions) {
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left; // x position within the element.
    const y = e.clientY - rect.top; // y position within the element.
    return { x: x / renderOptions.tileSize, y: y / renderOptions.tileSize };
}
exports.default = RealityRenderer;
//# sourceMappingURL=Renderer.js.map